function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.783 2.826L12 1l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L12 23l-6.328-4.219A6 6 0 013 13.79V3.802a1 1 0 01.783-.976zM5 4.604v9.185a4 4 0 001.781 3.328L12 20.597l5.219-3.48A4 4 0 0019 13.79V4.604L12 3.05 5 4.604zM13 10h3l-5 7v-5H8l5-7v5z",
  fill: "rgba(100,21,255,1)"
});

function SvgShieldIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDB6Ii8+PHBhdGggZD0iTTMuNzgzIDIuODI2TDEyIDFsOC4yMTcgMS44MjZhMSAxIDAgMCAxIC43ODMuOTc2djkuOTg3YTYgNiAwIDAgMS0yLjY3MiA0Ljk5MkwxMiAyM2wtNi4zMjgtNC4yMTlBNiA2IDAgMCAxIDMgMTMuNzlWMy44MDJhMSAxIDAgMCAxIC43ODMtLjk3NnpNNSA0LjYwNHY5LjE4NWE0IDQgMCAwIDAgMS43ODEgMy4zMjhMMTIgMjAuNTk3bDUuMjE5LTMuNDhBNCA0IDAgMCAwIDE5IDEzLjc5VjQuNjA0TDEyIDMuMDUgNSA0LjYwNHpNMTMgMTBoM2wtNSA3di01SDhsNS03djV6IiBmaWxsPSJyZ2JhKDEwMCwyMSwyNTUsMSkiLz48L3N2Zz4=";
export { SvgShieldIcon as ReactComponent };